import {TextField, Autocomplete} from "@mui/material";
import {useContext, useState} from "react";
import AuthContext from "../../context/AuthContext";
import {ThemeProvider, createTheme} from '@mui/material/styles';

const theme = createTheme({
    components: {
        MuiAutocomplete: {
            styleOverrides: {
                inputRoot: {
                    alignItems: 'center !important',
                },
            },
        },
    },
});


export default function AutoOneRuleDialog(props: any) {
    let {authTokens, serverIP} = useContext(AuthContext)

    const {name, fieldType, mapData, val, dialRule, setDialRule, condObject} = props
    // console.log(val)

    const queryData: any = {...mapData};
    queryData['fieldType'] = fieldType
    queryData['thisRule'] = dialRule
    queryData['condObj'] = condObject

    const [valuesArr, setValuesArr] = useState<any[]>(val ? [val] : [])

    return (
        <ThemeProvider theme={theme}>

            <Autocomplete
                key={1}
                value={val}
                onChange={(event, newValue) => {
                    // console.log(newValue)
                    if (newValue) {
                        setDialRule((prev: any) => {
                            return {...prev, [name]: newValue.label, fieldID: newValue.id}
                            })
                    } else {
                        setDialRule((prev: any) => {
                            return {...prev, [name]: '', fieldID: '', values: '[]', valueCondition: '', useAS: 'condition'}
                            })
                    }
                }}

                isOptionEqualToValue={(option, value) => option.value === value.value}

                onInputChange={(event, newValue) => {

                    if (newValue !== val) {

                        if ((isNaN(parseInt(newValue)) && newValue.length >= 3) || (!isNaN(parseInt(newValue)) && newValue.length >= 1)) {

                            queryData['qString'] = newValue

                            fetch(`${serverIP}/getsrcdata/`, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Bearer ' + String(authTokens.access)
                                },
                                body: JSON.stringify(queryData),
                            }).then(res => res.json())
                                .then((data) => {
                                    setValuesArr(data)
                                })
                        } else {
                            setValuesArr([])
                        }
                    }
                }
                }

                disablePortal
                autoHighlight
                forcePopupIcon={false}
                size="small"    // IMPORTANT! It is bind to the CSS class "MuiInputBase-sizeSmall"
                id="combo-box-demo"
                options={valuesArr}
                sx={{width: "auto"}}
                ListboxProps={
                    {
                        style: {
                            fontSize: '0.8rem',
                            fontFamily: "'Inter', sans-serif",
                            color: 'black'
                        }
                    }}

                renderInput={(params) =>
                    <TextField
                        {...params}
                        label=""
                        style={{backgroundColor: 'white'}}
                        // InputProps={{
                        //     style: {height: 30}
                        // }}
                    />}

            />
        </ThemeProvider>
    );
}
